import Flickity from 'flickity';
import 'flickity/css/flickity.css';
require('flickity-fade');

document.addEventListener('DOMContentLoaded', () => {

    const elem = document.querySelector('.top-bar-carousel');
    let top_bar_flkty;

    const initFlickity = () => {

        top_bar_flkty = new Flickity(elem, {
            wrapAround: true,
            autoPlay: false,
            fade: true,
        });

    jQuery('.top-bar-carousel').addClass('flickity-loaded');
    };

    if (elem) {
        initFlickity();

        window.addEventListener('resize', () => {
            jQuery('.top-bar-carousel').removeClass('flickity-loaded');
            top_bar_flkty.destroy();
            initFlickity();
        });
    }

});
